/**
 * Window-event bridge for the V.A.3 silent 10-minute auto-stop toast.
 * useSpeechToText dispatches this from its enhanced-mode onstop success
 * branch when the recording was auto-stopped at the cap; AutoStopToast
 * (mounted globally inside VoiceCaptureProvider) catches and surfaces
 * the "10 minutes captured…" message after the transcribed text lands.
 *
 * Lives in `lib/` rather than alongside AutoStopToast.tsx so the helper
 * + constant can be imported by both the toast component (subscriber)
 * and useSpeechToText (dispatcher) without violating the
 * `react-refresh/only-export-components` lint rule (a tsx file
 * exporting both a component and a non-component breaks fast refresh).
 */

export const VOICE_AUTO_STOP_EVENT = 'adia:voice-auto-stop';

export function dispatchVoiceAutoStop(): void {
  if (typeof window === 'undefined') return;
  try {
    window.dispatchEvent(new CustomEvent(VOICE_AUTO_STOP_EVENT));
  } catch {
    // Older browsers without CustomEvent — silently skip.
  }
}
